var $9839727223d77af8$exports = {};
$9839727223d77af8$exports = {
    "actions": `Ac\u{21B}iuni`,
    "hideButtonLabel": `Se afi\u{219}eaz\u{103} mai pu\u{21B}in`,
    "noTags": `Niciuna`,
    "showAllButtonLabel": (args, formatter)=>`Se afi\u{219}eaz\u{103} tot (${formatter.number(args.tagCount)})`
};


export {$9839727223d77af8$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
